import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const defaultTitle =
  "QComms - PR and Social Media Agency in the UAE, United Kingdom and Ireland";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      title: "Home" + " - " + defaultTitle,
      visible: true,
      metaTags: [
        {
          name: "description",
          content:
            "Q Communications specialises in fully integrated PR and Digital campaign strategies, helping launch brands, build awareness, establish credibility and manage reputations throughout the Middle East, United Kingdom and Ireland.",
        },
      ],
    },
  },
  {
    path: "/pr",
    name: "Public Relations & Communications",
    component: () => import("../views/PR.vue"),
    meta: {
      visible: true,
      title: "PR" + " - " + defaultTitle,
    },
  },
  {
    path: "/influencer",
    name: "Influencer",
    component: () => import("../views/Influencer.vue"),
    meta: {
      visible: true,
      title: "PR" + " - " + defaultTitle,
    },
  },
  {
    path: "/digital",
    name: "Digital",
    component: () => import("../views/Digital.vue"),
    meta: {
      visible: true,
      title: "Digital" + " - " + defaultTitle,
    },
  },
  {
    path: "/photography",
    name: "Photography",
    component: () => import("../views/Photography.vue"),
    meta: {
      visible: true,
      title: "Photography" + " - " + defaultTitle,
    },
  },
  {
    path: "/about",
    name: "About Us",
    component: () => import("../views/About.vue"),
    meta: {
      visible: true,
      title: "About" + " - " + defaultTitle,
    },
  },
  {
    path: "/work",
    name: "Our Work",
    component: () => import("../views/Work.vue"),
    meta: {
      visible: true,
      title: "Our Work" + " - " + defaultTitle,
    },
  },
  {
    path: "/careers",
    name: "Careers @ Q",
    component: () => import("../views/Careers.vue"),
    meta: {
      visible: true,
      title: "Careers @ Q" + " - " + defaultTitle,
    },
  },
  {
    path: "/blog",
    name: "Blog",
    component: () => import("../views/Blog.vue"),
    meta: {
      visible: true,
      title: "Blog" + " - " + defaultTitle,
    },
  },
  {
    path: "/article/:id/:date",
    name: "article",
    component: () => import("@/views/Article.vue"),
    meta: {
      visible: false,
      title: "Article" + " - " + defaultTitle,
    },
  },
  {
    path: "/project/:name",
    name: "project",
    component: () => import("@/views/Project.vue"),
    meta: {
      visible: false,
      title: "Project" + " - " + defaultTitle,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  }

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
    (el) => el.parentNode.removeChild(el)
  );

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map((tagDef) => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach((key) => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach((tag) => document.head.appendChild(tag));

  next();
});

export default router;
